export default {
  props: {
    modelValue: {},
    list: {}, // prevent inheritence of list="" on element,
    size: {}, // size property is for our usage, not for the element
  },
  data: function () {
    return {
      isFocused: false,
      testData: "test data value1",
    };
  },
  emits: ["update:modelValue", "field:changed"],
  computed: {
    value: {
      get() {
        if (typeof this.modelValue !== "string") {
          return this.modelValue;
        }

        if (this.modelValue.trim().startsWith(0)) {
          return this.modelValue;
        }

        if (this.modelValue.trim().startsWith("+972")) {
          return this.modelValue.trim().replace("+972", "0");
        }

        return this.modelValue;
      },
      set(newValue) {
        let finalValue = newValue;

        if (typeof newValue !== "string") {
          this.$emit("field:changed", finalValue.trim());
          this.$emit("update:modelValue", finalValue.trim());
          return true;
        }
        // make it regex safe
        finalValue = finalValue.slice(0, 100);
        // remove illegal chars
        finalValue = finalValue.replace(/[^\d+]/g, "");

        // accept normal numbers starting with 0 - standard local notation
        if (finalValue.trim().startsWith(0)) {
          finalValue = "+972" + finalValue.trim().replace("0", "");
        }

        // accept numbers without a leading +
        if (finalValue.trim().startsWith("972")) {
          finalValue = "+" + finalValue;
        }

        this.$emit("field:changed", finalValue.trim());
        this.$emit("update:modelValue", finalValue.trim());

        return true;
      },
    },

    inputAttrs() {
      let attrs = { ...this.$attrs };
      delete attrs.list;
      delete attrs.size;
      return attrs;
    },
  },
  watch: {},
  methods: {

  },
};
